import React from 'react';
import { 
    MonitorDot, 
    Building2, 
    UserCog, 
    Shield, 
    Users, 
    Mail, 
    MessageCircle, 
    ScrollText, 
    Calendar, 
    Clock, 
    ClipboardList, 
    CalendarDays, 
    FileText, 
    User, 
    Package, 
    CheckCircle, 
    Settings, 
    Folder, 
    Receipt, 
    DollarSign, 
    CreditCard, 
    Cog, 
    MessageSquare, 
    HelpCircle, 
    Navigation, 
    AlertTriangle, 
    Activity, 
    Home, 
    Route, 
    Codesandbox,
    MapPin,
    Search,
    QrCode,
    FileSpreadsheet
} from "lucide-react";

/**
 * Fallback Menu Configuration
 *
 * IMPORTANT:
 * When the dynamic menu system fails (or a new user has no menu assigned yet),
 * we show ONLY Dashboard. This prevents accidental exposure of pages like
 * Petty Cash or other tools via fallback menu.
 */

interface MenuItem {
    id?: string;
    label: string;
    link?: string;
    icon?: React.ReactElement;
    className: string;
    subItems?: MenuItem[];
    isTitle?: boolean;
    parentId?: number | string;
    roles?: string[];
    dynamicLink?: boolean;
}





const getFallbackDashboardOnlyMenu = (): MenuItem[] => [
    {
        id: "dashboard",
        label: "Dashboard",
        link: "/dashboard",
        icon: React.createElement(MonitorDot, { className: "text-emerald-600 hover:text-emerald-700 transition-colors" }),
        className: "hover:bg-emerald-50 border-l-4 border-transparent hover:border-emerald-500 [&.active]:border-emerald-500 transition-all duration-200"
    }
];

// Kept exports for backward compatibility, but they now return Dashboard only.
export const getFallbackEmployeeMenu = (): MenuItem[] => getFallbackDashboardOnlyMenu();

export const getFallbackAdminMenu = (): MenuItem[] => getFallbackDashboardOnlyMenu();

export const getFallbackSuperAdminMenuWithModuleManagement = (): MenuItem[] => getFallbackDashboardOnlyMenu();

// Get fallback menu based on user role
export const getFallbackMenuByRole = (role: string): MenuItem[] => {
    switch (role) {
        case 'Super Admin':
            // Super Admin gets Dashboard + Module Assignment + Profile
            return getFallbackSuperAdminMenuWithModuleManagement();
        case 'Admin':
            return getFallbackAdminMenu();
        case 'Manager':
        case 'Employee':
        case 'Staff':
        case 'Intern':
        default:
            // All other roles get Dashboard + Profile only
            return getFallbackEmployeeMenu();
    }
};
